/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        version="1.1"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M0 0h30v30H0V0z"
          fillRule="evenodd"/>
        <path
          fill="#4a4a4a"
          d="M22.45 18.09a5.45 5.45 0 0 1-.34 1.82 3.61 3.61 0 0 1-.87 1.33 3.82 3.82 0 0 1-1.33.87 5.45 5.45 0 0 1-1.82.34c-.8 0-1.05.05-3.09.05s-2.29 0-3.09-.05a5.45 5.45 0 0 1-1.82-.34 3.88 3.88 0 0 1-2.2-2.2 5.69 5.69 0 0 1-.35-1.82v-6.18a5.69 5.69 0 0 1 .35-1.82 3.82 3.82 0 0 1 .87-1.33 3.73 3.73 0 0 1 1.33-.87 5.45 5.45 0 0 1 1.82-.34h6.18a5.45 5.45 0 0 1 1.82.34 3.82 3.82 0 0 1 1.33.87 3.69 3.69 0 0 1 .87 1.33 5.45 5.45 0 0 1 .34 1.82c0 .8.05 1.05.05 3.09s0 2.29-.05 3.09M15 0a15 15 0 1 0 15 15A15 15 0 0 0 15 0"
          className="icon-fill"
          fillRule="evenodd"/>
        <path
          fill="#4a4a4a"
          d="M19 11.9a.9.9 0 0 1 0-1.8.9.9 0 1 1 0 1.8m-4 7a3.85 3.85 0 1 1 3.85-3.9A3.85 3.85 0 0 1 15 18.85m5.85-8.27a2.44 2.44 0 0 0-1.43-1.43A4.15 4.15 0 0 0 18 8.9c-.79 0-1-.05-3-.05s-2.24 0-3 .05a4.15 4.15 0 0 0-1.39.25 2.44 2.44 0 0 0-1.43 1.43A4.35 4.35 0 0 0 8.89 12v6a4.35 4.35 0 0 0 .26 1.39 2.44 2.44 0 0 0 1.43 1.43 4.15 4.15 0 0 0 1.42.28h6a4.15 4.15 0 0 0 1.39-.25 2.44 2.44 0 0 0 1.43-1.43A4.15 4.15 0 0 0 21.1 18v-6a4.15 4.15 0 0 0-.25-1.39"
          className="icon-fill"
          fillRule="evenodd"/>
        <path
          fill="#4a4a4a"
          d="M15 12.5a2.5 2.5 0 1 0 2.5 2.5 2.5 2.5 0 0 0-2.5-2.5"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>
    );
  }
}

Icon.displayName = 'InstagramIcon';

export default Icon;
